<template>
  <div class="life-warp">
    <div class="life-flex"  @click="goPage(lifeHomeInfo)">
      <h4 v-if="configInfo"><span :style="{'color': configInfo.titleColor}">{{configInfo.title || '生活家大标题'}}</span><a v-if="!configInfo.iconFlag" href="javascript:;" :style="{'border': `1px solid ${configInfo.sdColor}`, 'color': configInfo.sdColor}">{{configInfo.subTitle||'更多'}} <van-icon name="arrow" size=".22rem" :color="configInfo.sdColor"/></a></h4>
      <p v-if="configInfo" :style="{'color': configInfo.sdColor}">{{configInfo.description || '生活家描述'}}</p>
      <div class="life-list">
        <div class="life-list-item" v-for="item in lifeHomeInfo" :key="item.contentId">
          <img class="item-img" :src="item.coverUrls && item.coverUrls[0]">
          <img class="item-avatar" :src="item.user && item.user.icon">
          <p>{{item.user && item.user.nickname}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../api'
import { mapGetters } from 'vuex'
export default {
  name: 'lifeHome',
  props: {
    configInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      lifeHomeInfo: [], // 生活家数据
    }
  },
  computed: {
    ...mapGetters(['accessToken']),
  },
  mounted() {
    Api.getLifeHomeList({
      'count': '3',
      'contentTypes': ['article']
    }, {
      accessToken: this.accessToken
    }).then(({ data }) => {
      let result = data.data
      console.log('lifeHome==>', result)
      this.lifeHomeInfo = result.contents
    })
  },
  methods: {
    goPage(item) {
      this.$store.dispatch('goPageByType', {
        type: Number(item.hyperType),
        params: item.hyperParam,
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.life-warp{
  width: 3.1rem;
  /* padding: .24rem 0 .2rem; */
}

.life-flex{
  width: 3.14rem;
  margin-right: .16rem;
  > h4{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: .5rem;
    color: #333;
    font-weight: 600;
    span{
      max-width: 2rem;
      font-size: .3rem;
      font-weight: 600;
    }
    a{
      max-width: 1.4rem;
      margin-left: .1rem;
      display: inline-flex;
      align-items: center;
      padding: .02rem .14rem;
      font-size: .22rem;
      border-radius: .2rem;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  >p{
    font-size: .24rem;
    height: .36rem;
    line-height: .36rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // @include text-overflow(1);
    padding-top: .02rem;
  }
}

.life-list{
  margin-top: .12rem;
  display: flex;
  flex-wrap: nowrap;
}
.life-list-item{
  margin-right: .04rem;
  width: 1.02rem;
  text-align: center;
  font-size: 0;
  .item-img{
    display: inline-block;
    width: 1.02rem;
    height: 1.02rem;
    border-radius: .06rem;
  }
  .item-avatar{
    margin: .02rem 0;
    display: inline-block;
    width: .28rem;
    height: .28rem;
    border-radius: .14rem;
  };
  p{
    max-width: 1.02rem;
    font-size: .16rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
